// API Endpoints and Configuration
export const API_ENDPOINTS = {
  RESULTS: '/results',
  USERS: '/users',
  DASHBOARD: '/dashboard',
  ROUND_GROUPS: '/round-groups',
  ADMIN: {
    RECENT_REGISTRATIONS: '/users/admin/recent-registrations',
    RECENT_SCORECARDS: '/users/admin/recent-scorecards',
    CREATE_USER: '/users/admin/create',
    UPDATE_USER: '/users/admin',
  },
} as const

export const API_CONFIG = {
  TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
  DEFAULT_LIMIT: 10,
} as const

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const
